import script from "./ransomware-incident-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./ransomware-incident-list.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__